// components/AdMobBanner.js
import { useEffect, useState } from 'react';
import { AdMob, BannerAdSize, BannerAdPosition } from '@capacitor-community/admob';
import { Capacitor } from '@capacitor/core';

export default function AdMobBanner({ adUnitId = 'ca-app-pub-1120357008550196/7531187764' }) {
  const [isInitialized, setIsInitialized] = useState(false);

  useEffect(() => {
    // 모바일 앱에서만 AdMob 초기화
    if (Capacitor.isNativePlatform()) {
      const initializeAdMob = async () => {
        try {
          await AdMob.initialize({
            requestTrackingAuthorization: true,
            initializeForTesting: false, // 테스트 완료 후 false로 변경
          });
          setIsInitialized(true);
        } catch (error) {
          console.error('AdMob initialization failed:', error);
        }
      };

      initializeAdMob();
    }
  }, []);

  useEffect(() => {
    if (isInitialized && Capacitor.isNativePlatform()) {
      const showBanner = async () => {
        try {
          await AdMob.showBanner({
            adId: adUnitId,
            adSize: BannerAdSize.BANNER,
            position: BannerAdPosition.TOP_CENTER,
            margin: 0,
          });
        } catch (error) {
          console.error('AdMob banner show failed:', error);
        }
      };

      showBanner();

      // hideBanner를 제거하여 페이지 전환 시에도 광고가 계속 표시되도록 함
    }
  }, [isInitialized, adUnitId]);

  // 웹에서는 아무것도 렌더링하지 않음
  if (!Capacitor.isNativePlatform()) {
    return null;
  }

  // 네이티브 앱에서도 DOM에 아무것도 렌더링하지 않음 (AdMob이 네이티브로 표시됨)
  return null;
}
